import '../styles/Credits.css';
function Credits(){
    return(
        <div id="credits">
          <div className="ending-credits">
            <div><p>© Aby Huerta</p></div>
          </div>
        </div>
    );
}

export default Credits